import * as P from 'plow-js';
import { handleActions } from 'redux-actions';
// constants
import { ENUM_NONE } from '../../../constants';
// component header
import { headerRoutine, headerFileUploadStatusData } from './routines';
//////////////////////////////////////////////////

export const initialState = {
  error: null,
  loading: false,
  fileData: {
    fileName: '',
    processedOn: 0,
    processedEndDate: '',
    processedStartDate: '',
    processedStatus: ENUM_NONE,
  },
};

const setIsFileSuccess = state => P.$merge({ loading: false, error: null }, state);

const setFileUploadStatusSuccess = (state, { payload }) => P.$set('fileData', payload, state);

export default handleActions(
  {
    [headerRoutine.upload.SUCCESS]: setIsFileSuccess,
    [headerFileUploadStatusData.SUCCESS]: setFileUploadStatusSuccess,
  },
  initialState,
);
